export default __webpack_public_path__ + "static/media/adoptzi_step2.384fad14.png";